/* Copyright 2013 - 2026 Waiterio LLC */

const serializeJsonForScript = value =>
  JSON.stringify(value)
    .replaceAll('<', '\\u003c')
    .replaceAll('\u2028', '\\u2028')
    .replaceAll('\u2029', '\\u2029')

export default serializeJsonForScript
